import { render, staticRenderFns } from "./AppointmentCategories.vue?vue&type=template&id=906c2a8c"
import script from "./AppointmentCategories.vue?vue&type=script&lang=ts"
export * from "./AppointmentCategories.vue?vue&type=script&lang=ts"
import style0 from "./AppointmentCategories.vue?vue&type=style&index=0&id=906c2a8c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports